<template>
  <transition name="modal">
    <div
      class="custom-modal"
      id="modal"
      @click="handleOutsideClick"
      v-if="showModal"
    >
      <transition name="modal-content">
        <div
          id="modal-content"
          :style="{ width: width + '%' }"
          class="custom-modal-content"
        >
          <div class="modal-heading" :class="{ title: title }">
            <h1>{{ title }}</h1>
            <h1 class="cursor-pointer" @click="closeModal">X</h1>
          </div>
          <cropper
            v-if="editing"
            class="cropper"
            ref="cropper"
            stencil-component="circle-stencil"
            :src="getImage"
            :canvas="false"
            :stencil-props="{
              aspectRatio: 1/1
            }"
            @change="change"
          />
          <div v-else class="flex mx-auto  justify-center items-center object-contain">
            <img class="rounded-full w-64 h-64" :src="getImage" alt="image to be cropped">
          </div>
          <preview
            :width="120"
            :height="120"
            :image="result.image"
            :coordinates="result.coordinates"
          />
          <hr class="rule">
          <div class="flex justify-between m-4">
            <div class="flex justify-items-start gap-16">
              <span class="text-white flex flex-col gap-2 items-center cursor-pointer"  v-if="!editing" @click="editing = true">
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26.125 5.5625L21.4375 0.875L2.6875 19.625L0.8125 26.1875L7.375 24.3125L26.125 5.5625ZM17.6875 4.625L22.375 9.3125L17.6875 4.625ZM2.6875 19.625L7.375 24.3125L2.6875 19.625Z" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Edit
              </span>
              <span class="text-white flex flex-col gap-2 items-center cursor-pointer"  v-if="!editing" @click="addPhoto">
                <input ref="fileInput" type="file" @input="pickFile" accept="image/*" style="display: none;"/>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)">
                    <path d="M28.125 22.5C28.125 22.9973 27.9275 23.4742 27.5758 23.8258C27.2242 24.1775 26.7473 24.375 26.25 24.375H3.75C3.25272 24.375 2.77581 24.1775 2.42417 23.8258C2.07254 23.4742 1.875 22.9973 1.875 22.5V11.25C1.875 10.7527 2.07254 10.2758 2.42417 9.92418C2.77581 9.57254 3.25272 9.375 3.75 9.375H5.9475C7.43857 9.37418 8.86831 8.78138 9.9225 7.72687L11.4788 6.17438C11.8294 5.82364 12.3047 5.6261 12.8006 5.625H17.1956C17.6929 5.62511 18.1697 5.82272 18.5212 6.17438L20.0738 7.72687C20.5962 8.24946 21.2165 8.664 21.8992 8.94679C22.5818 9.22958 23.3136 9.37509 24.0525 9.375H26.25C26.7473 9.375 27.2242 9.57254 27.5758 9.92418C27.9275 10.2758 28.125 10.7527 28.125 11.25V22.5ZM3.75 7.5C2.75544 7.5 1.80161 7.89509 1.09835 8.59835C0.395088 9.30161 0 10.2554 0 11.25L0 22.5C0 23.4946 0.395088 24.4484 1.09835 25.1516C1.80161 25.8549 2.75544 26.25 3.75 26.25H26.25C27.2446 26.25 28.1984 25.8549 28.9016 25.1516C29.6049 24.4484 30 23.4946 30 22.5V11.25C30 10.2554 29.6049 9.30161 28.9016 8.59835C28.1984 7.89509 27.2446 7.5 26.25 7.5H24.0525C23.058 7.49979 22.1043 7.10456 21.4012 6.40125L19.8488 4.84875C19.1457 4.14544 18.192 3.75021 17.1975 3.75H12.8025C11.808 3.75021 10.8543 4.14544 10.1512 4.84875L8.59875 6.40125C7.89565 7.10456 6.94198 7.49979 5.9475 7.5H3.75Z" fill="white"/>
                    <path d="M15 20.625C13.7568 20.625 12.5645 20.1311 11.6854 19.2521C10.8064 18.373 10.3125 17.1807 10.3125 15.9375C10.3125 14.6943 10.8064 13.502 11.6854 12.6229C12.5645 11.7439 13.7568 11.25 15 11.25C16.2432 11.25 17.4355 11.7439 18.3146 12.6229C19.1936 13.502 19.6875 14.6943 19.6875 15.9375C19.6875 17.1807 19.1936 18.373 18.3146 19.2521C17.4355 20.1311 16.2432 20.625 15 20.625ZM15 22.5C16.7405 22.5 18.4097 21.8086 19.6404 20.5779C20.8711 19.3472 21.5625 17.678 21.5625 15.9375C21.5625 14.197 20.8711 12.5278 19.6404 11.2971C18.4097 10.0664 16.7405 9.375 15 9.375C13.2595 9.375 11.5903 10.0664 10.3596 11.2971C9.1289 12.5278 8.4375 14.197 8.4375 15.9375C8.4375 17.678 9.1289 19.3472 10.3596 20.5779C11.5903 21.8086 13.2595 22.5 15 22.5ZM5.625 12.1875C5.625 12.4361 5.52623 12.6746 5.35041 12.8504C5.1746 13.0262 4.93614 13.125 4.6875 13.125C4.43886 13.125 4.2004 13.0262 4.02459 12.8504C3.84877 12.6746 3.75 12.4361 3.75 12.1875C3.75 11.9389 3.84877 11.7004 4.02459 11.5246C4.2004 11.3488 4.43886 11.25 4.6875 11.25C4.93614 11.25 5.1746 11.3488 5.35041 11.5246C5.52623 11.7004 5.625 11.9389 5.625 12.1875Z" fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="30" height="30" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                Add Photo
              </span>
              <span class="text-white flex flex-col gap-2 items-center cursor-pointer"  v-if="editing" @click="handleCrop">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.75 6.75C21.75 5.37125 20.6287 4.25 19.25 4.25H6.75V0.5H4.25V4.25H0.5V6.75H19.25V25.5H21.75V21.75H25.5V19.25H21.75V6.75Z" fill="white"/>
                  <path d="M4.25 9.25V19.25C4.25 20.6287 5.37125 21.75 6.75 21.75H16.75V19.25H6.75V9.25H4.25Z" fill="white"/>
                </svg>
                Crop
              </span>
            </div>
            <span class="text-white flex flex-col gap-2 items-center cursor-pointer" v-if="!editing" @click="deletePhoto">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.25 11.25H13.125V22.5H11.25V11.25Z" fill="white"/>
                <path d="M16.875 11.25H18.75V22.5H16.875V11.25Z" fill="white"/>
                <path d="M3.75 5.625V7.5H5.625V26.25C5.625 26.7473 5.82254 27.2242 6.17417 27.5758C6.52581 27.9275 7.00272 28.125 7.5 28.125H22.5C22.9973 28.125 23.4742 27.9275 23.8258 27.5758C24.1775 27.2242 24.375 26.7473 24.375 26.25V7.5H26.25V5.625H3.75ZM7.5 26.25V7.5H22.5V26.25H7.5Z" fill="white"/>
                <path d="M11.25 1.875H18.75V3.75H11.25V1.875Z" fill="white"/>
              </svg>
              Delete
            </span>
            <base-button v-if="editing" @click="handleImageUpload" :loading="isUploadingImage" text="Save Photo" />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { Cropper, Preview } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
// import axios from "axios"
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
		Cropper,
    Preview
	},
  data(){
    return {
      img: 'https://images.pexels.com/photos/4323307/pexels-photo-4323307.jpeg',
      width: 60,
      loading:false,
      editing: false,
      isUploadingImage: false,
      result:{
        coordinates: null,
				image: null
      }
    }
  },
  watch:{

  },
  methods: {
    change({ coordinates, image }) { 
			this.result = {
				coordinates,
				image
			};
    },
    addPhoto(){
      this.$refs.fileInput.click()
    },
    async deletePhoto(){
      const response = await this.updateProfileImage(" ", "image deleted");
      console.log(response, "deleted");
      if(response != null){
        this.$emit('completed-picture-update');
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
    handleCrop(){
			const { coordinates, canvas, } = this.$refs.cropper.getResult();
			this.coordinates = coordinates;
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image, that can be used 
			// as src for <img/> to preview result
			this.image = canvas.toDataURL();
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0].size > 1048576) {
        this.generateToast(
          "Selected image size is too large. Please upload an image smaller than 1MB!",
          "error"
        );
      } else {
        if (file && file[0]) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.img = e.target.result;
          };
          reader.readAsDataURL(file[0]);

          this.handleImageUpload(file[0]);
          // this.$emit("input", file[0]);
        }
      }
    },
    handleOutsideClick() {
      let modal = document.getElementById("modal");
      if (event.target == modal) {
        this.$emit("close-modal");
      }
    },
    async handleImageUpload(image){
      const filePath = this.uploadImage(image);
      this.editing = false;
      if(filePath){
        const response = await this.updateProfileImage(filePath);
      console.log(response, "uploaded");
        if(response != null){
          this.$emit('completed-picture-update');
        }
      }
    }
  },
  computed:{
    getImage(){
      if(this.image !== null && this.image != ''){
        return this.image; 
      }
      return this.img; 
    }
  },
};
</script>

<style scoped>
.cropper {
	height: 600px;
	background: #DDD;
}
.rule{
  border: 0.3px solid white;
  margin: 1rem;
}

.custom-modal {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease 0.5s;
  /* padding: 30% 0; */
}

/* Modal Content/Box */
.custom-modal-content {
  background: #10233E;
  padding: 1.5rem;
  border: 1px solid #888;
  width: 40%;
  max-height: 90%;
  border-radius: 6px;
  overflow-y: auto;
}
.custom-modal-content::-webkit-scrollbar {
  width: 1rem;
}
.modal-heading {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
}
.modal-heading.title {
  border-bottom: 0.2px solid #a3a4a7;
}
.modal-heading h1 {
  font-weight: bold;
  font-size: 1rem;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
.modal-enter-to,
.modal-leave {
  opacity: 1;
  transform: translateY(0);
}
.modal-enter-active,
.modal-leave-active {
  transition: all ease 0.5s;
}

@media screen and (max-width: 768px) {
  .custom-modal-content {
    width: 100% !important;
    padding: 0.5rem;
  }
}
</style>
